import {ChangeDetectorRef, Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../base-modal/base-modal.component";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {
  editProfilesBloggerFormFields, editProfilesBloggerModalName
} from "../configs/edit-profiles-blogger-modal-config";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";

import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect, MatSelectChange} from "@angular/material/select";
import {RecordData, RecordUpdateRequestParams} from "../../../../types/records-table.types";
import {DialogData, EditProfilesBloggerFormField} from "../types/edit-profiles-blogger-modal.types";
import {bloggerProfilesResourceType} from "../configs/blogger-modal-config";

@Component({
  selector: 'app-edit-profiles-blogger-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatButton,

    MatOption,
    MatSelect
  ],
  templateUrl: './edit-profiles-blogger-modal.component.html',
  styleUrl: './edit-profiles-blogger-modal.component.scss'
})
export class EditProfilesBloggerModalComponent extends BaseModalComponent {
  private dialogData = inject<DialogData>(MAT_DIALOG_DATA);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  public readonly formFields = editProfilesBloggerFormFields;
  public formGroup: FormGroup = new FormGroup({});
  public profiles: Array<RecordData> = [];

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(editProfilesBloggerModalName);
    this.initForm();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(editProfilesBloggerModalName);
  }

  public async handleProfilesBloggerUpdate(): Promise<void> {
    const recordUpdateRequestParams: RecordUpdateRequestParams = {
      path: bloggerProfilesResourceType.path,
      recordId: this.formGroup.get('id' as string)?.value,
      fieldName: 'url',
      value: this.formGroup.get('url' as string)?.value
    };

    await this.updatedRecordField<RecordData>(recordUpdateRequestParams);
    this.closeDialog('cancel');
  }

  public handleSelectChange(event: MatSelectChange) {
    const selectedPartner = event.value;
    const selectedProfile = this.profiles?.find(option => option['url'] === selectedPartner);

    if (selectedProfile) {
      this.setValuesFromContact(selectedProfile);
    }

    this.cdr.detectChanges();
  }

  private initForm(): void {
    const fieldNames: Array<string> = this.formFields.map((field: EditProfilesBloggerFormField) => field.fieldName);
    this.formGroup = this.baseModalService.initForm(fieldNames);
    this.setFirstProfile();
  }

  private setFirstProfile(): void {
    this.profiles = this.dialogData.recordData['profiles'] as Array<RecordData>;
    if (!this.profiles.length) { return; }

    const firstProfile = this.profiles.at(0);
    if (!firstProfile) { return; }

    this.setValuesFromContact(firstProfile);
  }

  private setValuesFromContact(profile: RecordData): void {
    Object.keys(profile).forEach(key => {
      const control = this.formGroup.get(key);
      if (control) {
        control.setValue(profile[key]);
      }
    });
  }
}
